<div class="content-wrapper">
    <section class="content">
        <div class="box">
            <div class="box-body">
                <form [formGroup]="DelegateRecordsForm" (ngSubmit)="LoadAllDelegationList()">
                    <div class="panel panel-default">
                        <header class="panel-heading">
                            <h5 class="panel-title">My Delegations</h5>
                        </header>
                        <mat-card class="btnCard">
                            <button mat-stroked-button type="button" (click)="Reset()">Reset</button>
                            <button type="button" mat-stroked-button (click)="_commonService.Exit()">Exit</button>
                        </mat-card>
                        <div class="panel-body">
                            <div class="row">
                                <div class="form-group col-md-6">
                                    <label>Name of Delegate</label>
                                    <p-dropdown [options]="delegateList" placeholder="--Select name--" formControlName="DelegateName"
                                                filter="true">
                                    </p-dropdown>
                                </div>
                                <div class="form-group col-md-6">
                                    <label>Delegate Id</label>
                                    <input formControlName="UserGPN" placeholder="Delegate Id" style="height: 43px;">
                                </div>
                            </div>
                        </div>
                        <div class="panel-footer">
                            <button mat-stroked-button type="submit">Get Result</button>
                            <button mat-stroked-button type="button" (click)="DeleteRecord()">Remove Delegation</button>
                        </div>
                    </div>
                    <div class="tabel-loading-shade" *ngIf="isLoadingResults">
                        <mat-spinner *ngIf="isLoadingResults"></mat-spinner>
                    </div>
                    <div class="table-container">
                        <table mat-table [dataSource]="DelegateDataSource" style="width:100% !important">
                            <ng-container matColumnDef="Select">
                                <th mat-header-cell *matHeaderCellDef>
                                    <mat-checkbox (change)="$event ? masterToggle() : null"
                                                  [checked]="selection.hasValue() && isAllSelected()"
                                                  [indeterminate]="selection.hasValue() && !isAllSelected()"></mat-checkbox>
                                </th>
                                <td mat-cell *matCellDef="let row">
                                    <mat-checkbox (click)="$event.stopPropagation()" (change)="$event ? selection.toggle(row) : null"
                                                  [checked]="selection.isSelected(row)" [aria-label]="checkboxLabel(row)"></mat-checkbox>
                                </td>
                            </ng-container>
                            <ng-container matColumnDef="DelegateName">
                                <th mat-header-cell *matHeaderCellDef> Delegate Name </th>
                                <td mat-cell *matCellDef="let element" style="cursor:pointer;color:blue; text-decoration: underline;"> {{element.DelegateName}} </td>
                            </ng-container>
                            <ng-container matColumnDef="UserGPN">
                                <th mat-header-cell *matHeaderCellDef> Delegate Id </th>
                                <td mat-cell *matCellDef="let element" (click)="$event.stopPropagation()"> {{element.UserGPN}} </td>
                            </ng-container>
                            <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
                            <tr mat-row *matRowDef="let row; columns: displayedColumns;" style="cursor:pointer;"
                                (click)="ShowDetails(row)"></tr>
                        </table>
                    </div>
                    <div *ngIf="DelegateDataSource==null" style="text-align: center;">
                        <span style="color: red;">Record not found.</span>
                    </div>
                </form>
            </div>
        </div>
    </section>
</div>




